const host= 'shimizu.fi'
export { host }
